import { AxiosResponse } from 'axios';
import { uiState } from 'stores';

export function responseHandler(response: AxiosResponse) {
  uiState.setIsLoading(false);
  return response;
}
